// Libraries
import Axios from 'config/service.config'
import envConfig from 'config/env_config'

export const getServices = async category => {
  const { data } = await Axios({
    baseURL: envConfig.partner,
    url: '/services',
    withCredentials: true,
    params: {
      category,
      visibleToClient: true
    }
  })
  return data
}

export const getServiceById = async (id, options) => {
  const { ignoreActive } = options || {}
  const { data } = await Axios({
    baseURL: envConfig.partner,
    url: `/services/${id}`,
    withCredentials: true,
    params: {
      ignoreActive
    }
  })
  return data
}
